import { CurrencyPipe, isPlatformBrowser, NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { ListsService } from './../services/lists.service';
import { OrderService } from 'src/app/services/order.service';
import { CarouselService } from './../services/carousel.service';
import { Component, HostListener, OnDestroy, OnInit, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { ORDER_OPTIONS_LIST } from '../shared/utils';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { AppStateCart } from '../state/cart/cart.reducer';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { IvyCarouselModule } from 'angular-responsive-carousel2';
import { ProductCardComponent } from '../shared/components/product-card/product-card.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Subject, debounceTime, distinctUntilChanged, take, takeUntil } from 'rxjs';
import { SnackbarService } from '@services/snackbar.service';
import { Item as ItemRecomendations } from '../models/recomendations.model';
import { recommnedationsDummy } from '../dummies/recommendations.dummy';
import { MatDialog } from '@angular/material/dialog';
import { DepartmentDataEnum, DepartmentsFilters, Option, Item } from '@models/departments.model';
import { FilterModalComponent } from '../department/filter-modal/filter-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { CarouselData, Item as ItemCarousel, Subcategory, Brand } from '@models/carousel.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, MatFormFieldModule, ReactiveFormsModule, MatRadioModule, MatInputModule, CurrencyPipe, MatIconModule, RouterLink, MatFormFieldModule, IvyCarouselModule, NgFor, MatButtonModule, MatSelectModule, FormsModule, MatOptionModule, ProductCardComponent, LottieComponent, TitleCasePipe, TranslateModule, MatCheckboxModule]
})

export class CarouselComponent implements OnInit, OnDestroy {
  public filters: DepartmentsFilters = {
    page: 0,
    limit: 25,
    ecommerce: 'true',
    carrousel_id: '',
  };
  public promoResults = 0;
  public loading = true;
  public isMobile = false;
  public carouselProductsHeight = 364;
  public carouselProductsWidth = 200;
  public store_id: number;
  private subs = new Subject<void>();
  private priceSub = new Subject<void>();
  public shouldLoadMore = false;
  public brands: Brand[] = [];
  public subcategories: Subcategory[] = [];

  public products: ItemCarousel[] = [];
  public orderList = ORDER_OPTIONS_LIST;
  public minPriceForm = new FormControl(null);
  public maxPriceForm = new FormControl(null);
  public emptyProducts = false;
  public productsLength = 0;
  public firstLoad = true;
  public carousels: DepartmentDataEnum[] = [];
  public displayNoInternetConnection = false;
  public displayEmptyView = false;
  public displayGeneralError = false;
  public carouselRecommendations: any;
  public shouldDisplayRecommended = false;
  public token: string;
  public selectedOption: Option;
  public radioButtonOptions: Option[] = [];
  public carousel_id: any;
  private defaultStore = environment.defaultStore;
  @ViewChild('loader', { static: false }) loaderRef: any;

  public carousel: CarouselData = {
    title: '',
    carrousel_id: '',
    only_deals: false,
    categories: [],
    subcategories: [],
    brands: [],
    items: [],
    total: 0,
    combinations: []
  };
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  public isBrowser: boolean;
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.isBrowser) this.isMobile = window.innerWidth <= 1024;
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
  }
  public id: string;
  public cartItems: Item[] = [];
  public favouritesList: any;
  public carrouselName: string;
  private scrollListener: () => void;

  constructor(
    private router: Router,
    private ar: ActivatedRoute,
    private carouselService: CarouselService,
    @Inject(PLATFORM_ID) private platformId: string,
    private orderService: OrderService,
    private listsService: ListsService,
    private store: Store<AppStateCart>,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,

  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store;
  }

  async ngOnInit(): Promise<void> {
    this.getStoreId();
    if (this.isBrowser) this.isMobile = window.innerWidth <= 800;
    this.orderList.forEach((order: any) => {
      this.radioButtonOptions.push({
        id: order.id,
        value: order.value,
        type: order.type,
        label: order.label,
      });
    });
    this.filters.carrousel_id = this.ar.snapshot.queryParams.id;
    this.selectedOption = this.radioButtonOptions[0];
    this.carouselProductsHeight = this.isMobile ? 275 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
    await this.getFavourites();
    this.store.select('cart').pipe(takeUntil(this.subs)).subscribe(({ info }) => {
      this.cartItems = info?.items;
    });

    if (this.isBrowser) {
      this.getQueryParams();
      window.addEventListener('scroll', this.scrollListener = () => {
        const element = document.getElementById('loader');
        if (element) {
          const position = element.getBoundingClientRect();
          if (position.top >= 0 && (position.bottom - 500) <= window.innerHeight) {
            if (this.shouldLoadMore) {
              this.filters.page += 1;
              this.shouldLoadMore = false;
              this.getProducts('scroll');
            }
          }
        }
      });
    }

    this.minPriceForm.valueChanges.pipe(
      debounceTime(1000),
      takeUntil(this.priceSub),
      distinctUntilChanged()
    ).subscribe(({
      next: (data: number | null) => {
        this.filters.min_price = data;
        if (this.minPriceForm.valid && this.maxPriceForm.valid) {
          this.getProducts();
        }
      }
    }));

    this.maxPriceForm.valueChanges.pipe(
      debounceTime(1000),
      takeUntil(this.priceSub),
      distinctUntilChanged()
    ).subscribe(({
      next: (data: number | null) => {
        this.filters.max_price = data;
        if (this.minPriceForm.valid && this.maxPriceForm.valid) {
          this.getProducts();
        }
      }
    }));
    this.orderService.refreshHome$.pipe(takeUntil(this.subs)).subscribe((res: boolean) => {
      if (res) {
        if (this.isBrowser) window.location.reload();
      }
    });

    this.getProducts();
    // this.ar.queryParams.pipe(takeUntil(this.subs)).subscribe(async (params: any) => {
    //   if (params?.search) {
    //     this.filters.id = params?.id;
    //     this.resetFilters();
    //     this.setParams();
    //   } else {
    //     this.getQueryParams();
    //     this.setParams();
    //     await this.getProducts();
    //   }
    // });
  }

  private getQueryParams() {
    const { brand, ecommerce, promotion, order_name, order_price, keyword } = this.ar.snapshot.queryParams;
    if (ecommerce) this.filters.ecommerce = ecommerce;
    if (brand) this.filters.brand = brand;
    if (order_name) this.filters.order_name = order_name;
    if (order_price) this.filters.order_price = order_price;
    if (promotion) this.filters.promotion = promotion === 'true' ? true : false;
    if (keyword) this.filters.keyword = keyword;
  }


  public async handleDeleteFilters() {
    this.resetFilters();
    this.setParams();
    await this.getProducts();
  }


  public openFilterModal(): void {
    this.dialog.open(FilterModalComponent, {
      autoFocus: false,
      position: { top: 'top' },
      panelClass: ['animate__animated', 'animate__slideInUp', 'as-filter-modal'],
      width: '100vw',
      minHeight: '100vh',
      data: { subCategories: this.subcategories, brands: this.brands, filters: this.filters, type: 'filters', orderList: this.orderList, from: 'carrousel' }
    }).afterClosed().subscribe(({
      next: ({ clear, filters, index, event, min_price, max_price, subCategory }) => {
        if (clear === true) {
          this.handleDeleteFilters();
        } else if (clear === false) {
          if (min_price) {
            this.filters.min_price = min_price;
            this.minPriceForm.setValue(min_price);
          }
          if (max_price) {
            this.filters.max_price = max_price;
            this.maxPriceForm.setValue(max_price);
          }
          if (filters?.subcategory) this.filterSubcategory(filters?.subcategory, index, event);
          if (filters?.brand) this.filterBrand(filters?.brand, index, event);
        }
      }
    }));
  }



  public async getFavourites(): Promise<void> {
    if (this.isBrowser) {
      const token = JSON.parse(localStorage.getItem('token') || '{}');
      if (token?.jwt) {
        try {
          const res = await this.listsService.getFavouritesLists();
          this.favouritesList = res.data;
        } catch (error) { }
      }
    }
  }


  public resetFilters(): void {
    this.filters = {
      page: 0,
      limit: 25,
      carrousel_id: this.filters.carrousel_id,
      ecommerce: 'true'
    };
    this.selectedOption = this.radioButtonOptions[0];
    this.brands = [];
    this.subcategories = [];
    this.products = [];
    this.resetPriceFilter();
  }

  public resetPriceFilter() {
    this.minPriceForm.patchValue(null, { emitEvent: false });
    this.maxPriceForm.patchValue(null, { emitEvent: false });
  }

  private setParams(): void {
    const queryParams: any = {
      id: this.filters.carrousel_id,
      ecommerce: this.filters.ecommerce,
    };
    if (this.filters.brand) queryParams.brand = this.filters.brand;
    if (this.filters.min_price) queryParams.min_price = this.filters.min_price;
    if (this.filters.max_price) queryParams.max_price = this.filters.max_price;
    if (this.filters.order_price) queryParams.order_price = this.filters.order_price;
    if (this.filters.order_name) queryParams.order_name = this.filters.order_name;
    if (this.filters.promotion) queryParams.promotion = this.filters.promotion;

    this.router.navigate([`carrusel/${this.carrouselName}`], {
      queryParams: { id: this.filters.carrousel_id }
    });
  }


  public async getProducts(type?: string): Promise<void> {
    this.emptyProducts = false;
    this.loading = true;
    this.shouldLoadMore = false;
    this.getStoreId();
    try {
      const { data } = await this.carouselService.getCarousel(this.store_id, this.filters.carrousel_id, this.filters.page + 1, this.filters.limit, this.filters.subcategory ?? '', this.filters.category ?? '', this.filters.brand ?? '', this.filters.orden ?? '', this.filters.orden_type ?? '');
      this.carousel = {
        brands: data.brands,
        carrousel_id: data.carrousel_id,
        categories: data.categories,
        combinations: data.combinations,
        items: data.items,
        only_deals: data.only_deals,
        subcategories: data.subcategories,
        title: data.title,
        total: data.total
      };
      const cartItemsMap = this.cartItems?.reduce((map, item: any) => {
        map[item.item_id] = item;
        return map;
      }, {} as Record<string, any>) || {};
      const favouritesMap = this.favouritesList?.items?.reduce((map: any, el: any) => {
        el.items.forEach((item: any) => {
          map[item.sku] = true;
          map[item.id] = true;
        });
        return map;
      }, {} as Record<string, boolean>) || {};
      let itemsAux: ItemCarousel[] = [];
      itemsAux = data.items.map((item: Item) => {
        if (cartItemsMap[item.id]) {
          item.productFromCart = cartItemsMap[item.id];
        }
        if (favouritesMap[item.id]) {
          item.showHeart = true;
        }
        return item;
      });
      this.carousel.title = this.carousel.title.split('-').join(' ');
      if (type === 'scroll') {
        this.products = this.products.concat(itemsAux);
      } else {
        this.products = itemsAux;
      }
      this.productsLength = data?.total ?? 0;
      this.shouldLoadMore = this.products.length === this.productsLength ? false : true;
      if (this.brands.length === 0) {
        const selectedBrands: string[] = this.brands.filter((brand: Brand) => brand.checked).map((brand: Brand) => brand.brand);
        const brandsListAux: Brand[] = [];
        const brandNamesSet = new Set<string>();
        data.brands.forEach((brand: Brand) => {
          const brandName = brand.brand.toLocaleLowerCase();
          if (!brandNamesSet.has(brandName)) {
            brandNamesSet.add(brandName);
            if (selectedBrands.includes(brandName)) {
              brand.checked = true;
              brandsListAux.push(brand);
            } else {
              brand.checked = false;
              brandsListAux.push(brand);
            }
          }
        });
        this.brands = [];
        this.brands = brandsListAux;
      }

      if (this.subcategories.length === 0) {
        const selectedSubcategories: string[] = this.subcategories.filter((subcategory: Subcategory) => subcategory.checked).map((subcategory: Subcategory) => subcategory.subcategory);
        const subcategoryAuxList: Subcategory[] = [];
        const subcategoryNamesSet = new Set<string>();
        data.subcategories.forEach((subcategory: Subcategory) => {
          const subcategoryName = subcategory.subcategory.toLocaleLowerCase();
          if (!subcategoryNamesSet.has(subcategoryName)) {
            subcategoryNamesSet.add(subcategoryName);
            if (selectedSubcategories.includes(subcategoryName)) {
              subcategory.checked = true;
              subcategoryAuxList.push(subcategory);
            } else {
              subcategory.checked = false;
              subcategoryAuxList.push(subcategory);
            }
          }
        });
        this.subcategories = [];
        this.subcategories = subcategoryAuxList;
      }
      if (this.productsLength < 1) {
        this.products = [];
        this.carousels = [];
        this.promoResults = 0;
        this.shouldLoadMore = false;
        this.emptyProducts = true;

      } else {
        this.emptyProducts = false;
      }
      this.firstLoad = false;
      this.loading = false;


    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        switch (error.status) {
          // case 0:
          // if (!navigator.onLine) {
          //   this.displayNoInternetConnection = true;
          // } else {
          //   this.openSnackRetry();
          //   this.displayGeneralError = true;
          // }
          // break;

          case 404:
            this.emptyProducts = true;
            this.products = [];
            this.carousels = [];
            this.promoResults = 0;
            break;
        }
      }
      this.goUp();
      this.shouldLoadMore = false;
      this.firstLoad = false;
      this.loading = false;
    }


  }

  // private resetDisplayedErrors() {
  //   this.displayNoInternetConnection = false;
  //   this.displayEmptyView = false;
  //   this.displayGeneralError = false;
  // }


  private getStoreId() {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store ?? this.defaultStore;
    }
  }

  public async getCarousels(): Promise<any> {
    this.carouselRecommendations = [];
    try {
      if (JSON.stringify(this.token) !== '{}' && this.store_id) {
        this.shouldDisplayRecommended = true;
        this.carouselService.getSuggestedCarousel(this.store_id, false).pipe(take(1)).subscribe(({

          next: ({ data }) => {
            //* Asigna las recomendaciones del carrusel obtenidas a la variable de clase.
            this.carouselRecommendations = data.message;

            //* Crea un mapa de artículos del carrito para acceso rápido.
            const cartItemsMap = new Map(this.cartItems?.map((item: any) => [item.item_id, item]));

            //* Crea un conjunto de artículos favoritos para acceso rápido.
            const favouritesSet = new Set(this.favouritesList?.items?.flatMap((el: any) => el.items.map((item: any) => item.sku)));

            //* Verifica si hay artículos en las recomendaciones del carrusel.
            if (this.carouselRecommendations.items.length) {
              //* Itera sobre los artículos del carrusel.
              this.carouselRecommendations.items.forEach((item2: ItemRecomendations) => {
                //* Marca los artículos del carrito en las recomendaciones del carrusel.
                if (cartItemsMap.has(item2.id)) {
                  item2.productFromCart = cartItemsMap.get(item2.id);
                }

                //* Marca los artículos favoritos en las recomendaciones del carrusel.
                if (favouritesSet.has(item2.sku) || favouritesSet.has(item2.id)) {
                  item2.showHeart = true;
                }
              });
            }
          },
          error: () => {
            this.carouselRecommendations = recommnedationsDummy;
          }
        }));
      } else {
        this.carouselRecommendations = recommnedationsDummy;
      }
    } catch (error) { }
  }





  public onSeeMoreNavigation(): void {
    if (this.isBrowser) window.scroll(0, 0);
  }



  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
    if (this.isBrowser) window.removeEventListener('scroll', this.scrollListener);
  }

  public openSnackRetry(): void {
    const snackbar = this.snackbarService.openSnackbar('ERROR-MESSAGES.wentWrongDonTWorry', 'warn', true, true, 'ERROR-MESSAGES.retry');
    snackbar.afterDismissed().subscribe(() => {
      this.getProducts();
    });
  }


  private goUp(): void {
    if (this.isBrowser) window.scroll(0, 0);
  }



  public filterBrand(brand: string, index: number, event: any): void {
    this.brands[index].checked = !this.brands[index].checked;
    const brands = this.filters.brand?.split('-') ?? [];
    if (event.checked) {
      brands.push(brand.trim());
    } else {
      const indexFilter = brands.indexOf(brand);
      brands.splice(indexFilter, 1);
    }
    let type = '';
    const selectedBrands: string[] = this.brands.filter((brand: Brand) => brand.checked).map((brand: Brand) => brand.brand);
    if (selectedBrands.length === 0) {
      type = 'refresh';
    }
    this.filters.page = 0;
    this.filters.brand = selectedBrands.join(',');
    this.goUp();
    this.getProducts(type);
  }

  public filterSubcategory(subcategory: string, index: number, event: any): void {
    this.subcategories[index].checked = !this.subcategories[index].checked;
    const subcategories = this.filters.subcategory?.split('-') ?? [];
    if (event.checked) {
      subcategories.push(subcategory.trim());
    } else {
      const indexFilter = subcategories.indexOf(subcategory);
      subcategories.splice(indexFilter, 1);
    }
    let type = '';
    const selectedSubcategories: string[] = this.subcategories.filter((subcategory: Subcategory) => subcategory.checked).map((subcategory: Subcategory) => subcategory.subcategory);
    if (selectedSubcategories.length === 0) {
      type = 'refresh';
    }
    this.filters.subcategory = selectedSubcategories.join(',');
    this.filters.page = 0;
    this.goUp();
    this.getProducts(type);
  }



  public openOrderModal(): void {
    this.dialog.open(FilterModalComponent, {
      autoFocus: false,
      position: { top: 'top' },
      panelClass: ['animate__animated', 'animate__slideInUp', 'as-filter-modal'],
      width: '100vw',
      minHeight: '100vh',
      data: { brands: this.brands, filters: this.filters, type: 'order', orderList: this.radioButtonOptions, optionSelected: this.selectedOption }
    }).afterClosed().subscribe(({
      next: ({ order }: { order: Option }) => {
        if (order) {
          this.selectedOption = order;
        } this.selectOrder(order);
      }
    }));
  }


  public deletePrice(): void {
    this.filters.min_price = null;
    this.filters.max_price = null;
    this.minPriceForm.reset();
    this.maxPriceForm.reset();
  }
  public deleteSubcategory(subcategoryToDelete: string): void {
    const i = this.subcategories.findIndex((subcategory: Subcategory) => subcategory.subcategory === subcategoryToDelete);
    this.subcategories[i].checked = false;
    let type = '';
    const selectedSubcategories: string[] = this.subcategories.filter((subcategory: Subcategory) => subcategory.checked).map((subcategory: Subcategory) => subcategory.subcategory);
    if (selectedSubcategories.length === 0) {
      type = 'refresh';
    }
    this.filters.page = 0;
    this.filters.subcategory = selectedSubcategories.join(',');
    this.goUp();
    this.getProducts(type);
  }


  public deleteBrand(brandToDelete: string): void {
    const i = this.brands.findIndex((brand: Brand) => brand.brand === brandToDelete);
    this.brands[i].checked = false;
    let type = '';
    const selectedBrands: string[] = this.brands.filter((brand: Brand) => brand.checked).map((brand: Brand) => brand.brand);
    if (selectedBrands.length === 0) {
      type = 'refresh';
    }
    this.filters.page = 0;
    this.filters.brand = selectedBrands.join(',');
    this.goUp();
    this.getProducts(type);
  }

  public selectOrder(option: Option): void {
    switch (option.type) {
      case 'result':
        delete this.filters.orden;
        delete this.filters.orden_type;
        break;
      case 'price':
      case 'name':
        this.filters.orden = option.value;
        this.filters.orden_type = option.type;
        break;
    }
    this.filters.page = 0;
    this.goUp();
    this.getProducts();
  }
}
